import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class CommercialDrivingLicenseAvailability extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'Do You Have a Valid Commercial Driver’s License (CDL)?',
    errorMessage: 'Please Answer on Question',
  };
}
